var React = require('react');

function CloseDialog (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M238.369,0C106.726,0,0,106.726,0,238.369c0,131.675,106.726,238.369,238.369,238.369 c131.675,0,238.369-106.694,238.369-238.369C476.737,106.726,370.043,0,238.369,0z M348.813,150.395l-88.578,88.61l78.407,87.338 c6.198,6.198,6.198,16.304,0,22.47c-6.166,6.198-16.273,6.198-22.438,0l-78.407-87.338l-87.37,87.338 c-6.198,6.198-16.273,6.198-22.47,0c-6.198-6.166-6.198-16.273,0-22.47l88.578-88.578l-78.376-87.37 c-6.198-6.198-6.198-16.273,0-22.47s16.273-6.198,22.47,0l78.407,87.37l87.338-87.37c6.198-6.198,16.273-6.198,22.47,0 C355.042,134.122,355.01,144.197,348.813,150.395z"}));
}

CloseDialog.defaultProps = {"version":"1.1","viewBox":"0 0 476.737 476.737","width":"24","height":"24","style":{"enableBackground":"new 0 0 476.737 476.737"}};

module.exports = CloseDialog;

CloseDialog.default = CloseDialog;
